import React from 'react';
import { TableCell, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { convertTokens } from '@date-fns/upgrade/v2';

import { ProviderType } from 'generated/graphql';
import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

import { TransactionTypeLabels } from '../constants';
import { getTransactionDateForTransaction } from '../summarizeTransactions';
import { Transaction } from '../types';

import { TransactionTableRow } from './TransactionTableRow';

export const GivingAccountFundingTransactionRow = ({
  transaction,
  accountCurrency,
  accountProvider,
}: {
  transaction: Extract<Transaction, { __typename: 'GivingAccountFunding' }>;
  accountCurrency: CurrencyCode;
  accountProvider: ProviderType;
}) => (
  <TransactionTableRow>
    <TableCell style={{ paddingLeft: 4 }} />
    <TableCell style={{ paddingLeft: 0 }}>
      <Typography variant="body2">
        {format(
          new Date(getTransactionDateForTransaction(transaction)),
          convertTokens('MMM DD, YYYY')
        )}
      </Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{TransactionTypeLabels[transaction.__typename]}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{transaction.description ?? transaction.identifier}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{accountProvider}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{currencyFormat(transaction.amount, accountCurrency)}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">
        {typeof transaction.balance === 'number' &&
          currencyFormat(transaction.balance, accountCurrency)}
      </Typography>
    </TableCell>
    <TableCell />
  </TransactionTableRow>
);
